// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/util/tendermint_proxy/v1/tendermint_proxy.proto (package penumbra.util.tendermint_proxy.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ABCIQueryRequest, ABCIQueryResponse, BroadcastTxAsyncRequest, BroadcastTxAsyncResponse, BroadcastTxSyncRequest, BroadcastTxSyncResponse, GetBlockByHeightRequest, GetBlockByHeightResponse, GetStatusRequest, GetStatusResponse, GetTxRequest, GetTxResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/util/tendermint_proxy/v1/tendermint_proxy_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Defines the gRPC query service for proxying requests to an upstream Tendermint RPC.
 *
 * @generated from service penumbra.util.tendermint_proxy.v1.TendermintProxyService
 */
export const TendermintProxyService = {
  typeName: "penumbra.util.tendermint_proxy.v1.TendermintProxyService",
  methods: {
    /**
     * Status queries the current status.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.GetStatus
     */
    getStatus: {
      name: "GetStatus",
      I: GetStatusRequest,
      O: GetStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Broadcast a transaction asynchronously.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.BroadcastTxAsync
     */
    broadcastTxAsync: {
      name: "BroadcastTxAsync",
      I: BroadcastTxAsyncRequest,
      O: BroadcastTxAsyncResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Broadcast a transaction synchronously.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.BroadcastTxSync
     */
    broadcastTxSync: {
      name: "BroadcastTxSync",
      I: BroadcastTxSyncRequest,
      O: BroadcastTxSyncResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Fetch a transaction by hash.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.GetTx
     */
    getTx: {
      name: "GetTx",
      I: GetTxRequest,
      O: GetTxResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ABCIQuery defines a query handler that supports ABCI queries directly to the
     * application, bypassing Tendermint completely. The ABCI query must contain
     * a valid and supported path, including app, custom, p2p, and store.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.ABCIQuery
     */
    aBCIQuery: {
      name: "ABCIQuery",
      I: ABCIQueryRequest,
      O: ABCIQueryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetBlockByHeight queries block for given height.
     *
     * @generated from rpc penumbra.util.tendermint_proxy.v1.TendermintProxyService.GetBlockByHeight
     */
    getBlockByHeight: {
      name: "GetBlockByHeight",
      I: GetBlockByHeightRequest,
      O: GetBlockByHeightResponse,
      kind: MethodKind.Unary,
    },
  }
};

